export type BuilderNavigationVariantOption<Value extends string = string> = {
  description: string;
  label: string;
  value: Value;
};

export type BuilderNavigationVariantPickerAction = {
  disabled?: boolean;
  id: string;
  label: string;
  onSelect: () => Promise<void> | void;
};

export type BuilderNavigationSelectOption = {
  label: string;
  value: string;
};

export type BuilderNavigationSelectControl = {
  key: string;
  label: string;
  onChange: (value: string) => void;
  options: readonly BuilderNavigationSelectOption[];
  value: string;
};

export function builderNavigationVariantOptions<Value extends string>(
  variants: readonly Value[],
  label: (variant: Value) => string,
  description: (variant: Value) => string,
): BuilderNavigationVariantOption<Value>[] {
  return variants.map((variant) => ({
    description: description(variant),
    label: label(variant),
    value: variant,
  }));
}

export function builderNavigationEditorHref(
  baseHref: string,
  location: string,
): string {
  const separator = baseHref.includes("?") ? "&" : "?";

  return `${baseHref}${separator}location=${encodeURIComponent(location)}`;
}
